import { useLanguage } from "@/i18n/LanguageContext";
import { AlertTriangle } from "lucide-react";

interface StockIndicatorProps {
  stockQuantity?: number;
  stockStatus?: string;
  className?: string;
}

const StockIndicator = ({ stockQuantity, stockStatus, className = "" }: StockIndicatorProps) => {
  const { isAr } = useLanguage();

  if (stockStatus === "out_of_stock") {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full bg-destructive/95 text-destructive-foreground font-body text-[10px] uppercase tracking-wider font-semibold px-3 py-1 shadow-sm backdrop-blur-sm ${className}`}>
        {isAr ? "نفذ من المخزون" : "Sold Out"}
      </span>
    );
  }

  if (stockStatus === "low_stock" || (stockQuantity != null && stockQuantity > 0 && stockQuantity <= 10)) {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full bg-primary/95 text-primary-foreground font-body text-[10px] uppercase tracking-wider font-semibold px-3 py-1 shadow-sm backdrop-blur-sm ${className}`}>
        <AlertTriangle size={10} strokeWidth={2.5}  aria-hidden="true" focusable="false" />
        {isAr ? `باقي ${stockQuantity} فقط` : `Only ${stockQuantity} left`}
      </span>
    );
  }

  return null;
};

export default StockIndicator;
